import React from "react";
import { createPortal } from 'react-dom';
import PropTypes from "prop-types";
import { css } from 'react-emotion';
import bhole from 'assets/images/bhole.png';

const propTypes = {
  title: PropTypes.any.isRequired,
  subtitle: PropTypes.any.isRequired,
  children: PropTypes.any,
};

class Error extends React.Component {
  node = document.getElementById('overlay');

  render() {
    const { title, subtitle, children } = this.props;

    const content = (
      <div className={page404}>
        <div className="page404_wrapper">
          <div className="page404_text">
            <h2>{title}</h2>
            <h5>
              {subtitle}
            </h5>
            {children && children}
          </div>
        </div>
      </div>
    );

    if(!this.node) return content;
    return createPortal(content, this.node);
  }
}

Error.propTypes = propTypes;
export default Error;

const page404 = css`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;
  background: rgba(0, 0, 0, 0.1);
  background: radial-gradient(#221138, #070011);

  .page404_text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fefefe;
      border-radius: 4px;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25), 2px 12px 45px 15px rgba(0, 0, 0, 0.15);
      width: 40%;
      max-width: 500px;
      min-width: 450px;
  }

  .page404_wrapper {
      background: url(${bhole}) center no-repeat;
      position: absolute;
      width: 100%;
      height: 100%;
  }
  .page404_text {
      background: none;
      box-shadow: none;
      top: 60%;
      transform: translate(-50%, -60%);
      text-align: center;
      width: 75%;
      max-width: initial;
      min-width: 300px;
  }
  .page404_text h2 {
      color: #fff;
      font-size: 42px;
      font-weight: 100;
      margin-bottom: 30px;
  }

  .page404_text a {
    margin: 70px auto 0;
    display: inline-block;
    line-height: 35px;
  }
`;


// WEBPACK FOOTER //
// ./src/components/ui/Error.jsx